module.exports = __webpack_public_path__ + "img/man_contact.90462380.png";